import { actionDraw } from "../deck/actionDraw.js";
import type { CardInstanceId, RunState } from "../types/index.js";

function isHandCard(run: RunState, id: CardInstanceId): boolean {
  return run.hand.some((item) => item.instanceId === id);
}

export function toggleWorkerCycle(run: RunState, id: CardInstanceId): RunState | null {
  const pending = run.pendingChoice;
  if (pending?.kind !== "workerCycle" || !isHandCard(run, id)) return null;
  const selected = pending.selected[0] === id ? [] : [id];
  return { ...run, pendingChoice: { ...pending, selected } };
}

export function resolveWorkerCycle(run: RunState): { run: RunState; reshuffled: boolean } {
  const pending = run.pendingChoice;
  if (pending?.kind !== "workerCycle") return { run: { ...run, pendingChoice: null }, reshuffled: false };
  const id = pending.selected[0];
  if (!id || !isHandCard(run, id)) return { run: { ...run, pendingChoice: null }, reshuffled: false };

  const chosen = run.hand.find((card) => card.instanceId === id)!;
  const hand = run.hand.filter((card) => card.instanceId !== id);
  const drawn = actionDraw({ ...run, discard: [...run.discard, chosen] }, pending.draw);
  return {
    reshuffled: drawn.reshuffled,
    run: {
      ...drawn.run,
      hand: [...hand, ...drawn.drawn],
      deck: drawn.deck,
      discard: drawn.discard,
      rngState: drawn.rngState,
      energy: run.energy + pending.actions,
      pendingChoice: null,
    },
  };
}
